/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Blocked_DescriptionInputs */



/**
* | output |
* | --- |
* | "This chat has been blocked due to a compliance violation. You cannot send any more messages. Please contact your administrator for more information." |
*
* @param {Chat_Blocked_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_blocked_description = /** @type {((inputs?: Chat_Blocked_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Blocked_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Chat wurde aufgrund eines Compliance-Verstoßes gesperrt. Sie können keine weiteren Nachrichten senden. Bitte kontaktieren Sie Ihren Administrator für weitere Informationen.")
	return /** @type {LocalizedString} */ ("This chat has been blocked due to a compliance violation. You cannot send any more messages. Please contact your administrator for more information.")
});